import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { useNotification } from "../hooks";

const deleteTestSteps = async ({ data, params }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteTestSteps&companyid=${user.companyid}`,
      data,
      {
        params,
      },
    )
    // .then((response) => {
    //   return response;
    // })
    // .catch((error) => {
    //   console.log(error.response.data.error);
    // });

  return response.data;
};

const changeToAssert = async ({ data, params }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=changeToAssert&companyid=${user.companyid}`,
      data,
      {
        params,
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });

  return response.data;
};

const useDeleteTestStepsMutation = () => {
  const queryClient = useQueryClient();
  const notify = useNotification();

  return useMutation({
    mutationFn: deleteTestSteps,

    onSuccess: () => {
      queryClient.invalidateQueries(["testCaseList"]);
      notify("Test steps deleted successfully.", "success");
    },

    onError: (error) => {
      if (error?.response?.data?.failed) {

        const failed = error.response.data.failed;

        let message = "Some test steps could not be deleted.\n";

        failed.forEach((f) => {
          f.dependentTestSteps.forEach((d) => {
            message += `• ${d.testCaseName} (Step ${d.stepNumber})\n`;
          });
        });

        notify(message, "error");
      } else {
        notify("Failed to delete test steps. Please try again.", "error");
      }
    },
  });
};

export default useDeleteTestStepsMutation;
